// Static content — projects, films, press, ventures.
// Curated cinematic placeholders for film posters (no actual rights to real posters).

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/7zssbowd_Gemini_Generated_Image_e3amy7e3amy7e3adm.png";

export const VENTURE_MUSIC =
  "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/ojizqb7s_Maajja.png";

export const VENTURE_FILM =
  "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/tgiows5j_IDeal%20entertainment.png";

export const BLOG_HERO =
  "https://static.prod-images.emergentagent.com/jobs/45a9c154-d69a-402e-bec0-20c78f1da501/images/1c0ae1158e0b6cb82bbb599c77ef8c6c8e890736ff2fbdc88c37657b8719645c.png";

export const FILMS = [
  {
    title: "She Came Back",
    year: 2024,
    role: "Producer",
    synopsis:
      "A character-driven drama exploring memory, return, and the silences inside a family across two continents.",
    poster:
      "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/1rjxo5cv_She%20came%20back%20.jpg",
    imdb: "https://www.imdb.com/",
  },
  {
    title: "Galaxy Built on Hope",
    year: 2022,
    role: "Producer",
    synopsis:
      "A sweeping documentary feature about ambition, faith, and the people who carry a community's dreams forward.",
    poster:
      "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/eozcux88_Galaxy%20build%20hope.jpg",
    imdb: "https://www.imdb.com/",
  },
  {
    title: "99 Songs",
    year: 2021,
    role: "Producer (with A.R. Rahman)",
    synopsis:
      "A music-driven feature conceived and scored by A.R. Rahman — a meditation on the cost of artistic devotion.",
    poster:
      "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/da4fgibr_99%20song.jpg",
    posterPosition: "right center",
    imdb: "https://www.imdb.com/title/tt6924650/",
  },
  {
    title: "LeMusk",
    year: 2022,
    role: "Producer",
    synopsis:
      "An immersive cinematic experience that pushes the boundaries of how music and story can be felt, not just watched.",
    poster:
      "https://customer-assets.emergentagent.com/job_shaji-nada-producer/artifacts/596q9tin_Le%20musk.jpg",
    posterPosition: "left center",
    imdb: "https://www.imdb.com/",
  },
];

export const FEATURED_PROJECTS = [
  { name: "Maajja", tagline: "Independent music label", image: VENTURE_MUSIC, href: "/ventures", contain: true },
  { name: "Ideal Entertainment", tagline: "Film & content production", image: VENTURE_FILM, href: "/ventures", contain: true, lightBg: true },
  { name: "She Came Back", tagline: "2024 — Producer", image: FILMS[0].poster, href: "/films" },
  { name: "Galaxy Built on Hope", tagline: "2022 — Producer", image: FILMS[1].poster, href: "/films" },
  { name: "99 Songs", tagline: "with A.R. Rahman", image: FILMS[2].poster, href: "/films", posterPosition: "right center" },
  { name: "LeMusk", tagline: "Immersive experience", image: FILMS[3].poster, href: "/films", posterPosition: "left center" },
];

export const PRESS_OUTLETS = [
  "Rolling Stone India",
  "The Week",
  "CBC",
  "American Bazaar",
  "Tamil Culture",
  "Radio and Music",
];

export const PRESS_QUOTES = [
  {
    quote:
      "Maajja is rewriting the playbook for independent South Asian music — and the world is finally listening.",
    outlet: "Rolling Stone India",
    href: "https://rollingstoneindia.com/",
  },
  {
    quote:
      "A producer who treats artists as partners, not assets — Shaji Nada is quietly building the infrastructure for a global diaspora wave.",
    outlet: "The Week",
    href: "https://www.theweek.in/",
  },
  {
    quote:
      "The story of \"Enjoy Enjaami\" — over a billion streams — is also the story of a new model of artist ownership.",
    outlet: "CBC",
    href: "https://www.cbc.ca/",
  },
  {
    quote:
      "Toronto's quiet kingmaker in the South Asian entertainment economy.",
    outlet: "American Bazaar",
    href: "https://www.americanbazaaronline.com/",
  },
  {
    quote:
      "Few executives have done more to put Tamil independent music in front of a global audience.",
    outlet: "Tamil Culture",
    href: "https://tamilculture.com/",
  },
  {
    quote:
      "Maajja's partnership model has become the reference point for how a modern label should treat its artists.",
    outlet: "Radio and Music",
    href: "https://www.radioandmusic.com/",
  },
];

export const SOCIALS = [
  { name: "LinkedIn", href: "https://www.linkedin.com/" },
  { name: "Instagram", href: "https://www.instagram.com/" },
  { name: "X", href: "https://x.com/" },
  { name: "YouTube", href: "https://www.youtube.com/" },
  { name: "IMDb", href: "https://www.imdb.com/" },
];
